import { createStore } from '../store'

const StoreService = {

  _store: {},
  
  createStore() {
    this._store = createStore()
    return this._store
  },
  
  store(store) {
    return _.get(this._store, store)
  }

}

export default StoreService

export {StoreService}